import { apiSlice } from "./ApiSlice";

const PharmacyOrderApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    AddPharmacyOrder: builder.mutation({
      query: data => {
        return {
          url: "/Customer-AddCustomer",
          method: "POST",
          body: data,
        };
      },
    }),

    OrderPayment: builder.mutation({
      query: data => {
        return {
          url: "/Phrmcy-Payment",
          method: "POST",
          body: data,
        };
      },
    }),

    PostFilteredPurchase: builder.mutation({
      query: (data) => ({
        url: `/PurchaseTable-withFilter`,
        method: "POST",
        body: data,
      }),
    }),

     GetAllPurchaseView: builder.query({
      query: ({ pharmaId, distributorId }) => ({
        url: `purchase-Get-DistributorTransactionsTables?PharmaId=${pharmaId}&distributorId=${distributorId}`,
        method: "GET",
      }),
    }),

    GetPurchaseDetails: builder.query({
      query: ({ pharmaId, purchaseId}) => ({
        url: `purchase-Get-PurchaseDetails?PharmaId=${pharmaId}&purchaseId=${purchaseId}`,
        method: "GET",
      }),
    }),
    
  }),
});

export const { useAddPharmacyOrderMutation, useOrderPaymentMutation,usePostFilteredPurchaseMutation,useLazyGetAllPurchaseViewQuery, useLazyGetPurchaseDetailsQuery } = PharmacyOrderApiSlice;
